import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { useIntl } from 'react-intl-next';
import { N20, N70 } from '@atlaskit/theme/colors';
import { DisplayMode } from '../../RenderForm';
import { longDateOnlyFormat, longTimeOnlyFormat } from '../common/defaultDateTimeFormats';
import { ViewWrapper } from '../common/questionWrappers';
function parseDatetimeValueForView(dateAnswer, timeAnswer, intl) {
  var formattedDateValue = dateAnswer.length < 1 ? '' : new Intl.DateTimeFormat(intl.locale, _objectSpread(_objectSpread({}, longDateOnlyFormat), {}, {
    timeZone: 'UTC'
  })).format(new Date(dateAnswer));
  var formattedTimeValue = '';
  if (timeAnswer.length) {
    var timeSplit = timeAnswer.split(':');
    var hours = parseInt(timeSplit[0], 10);
    var minutes = parseInt(timeSplit[1], 10);
    formattedTimeValue = new Intl.DateTimeFormat(intl.locale, _objectSpread(_objectSpread({}, longTimeOnlyFormat), {}, {
      timeZone: 'UTC'
    })).format(Date.UTC(0, 0, 1, hours, minutes));
  }
  return {
    formattedDateValue: formattedDateValue,
    formattedTimeValue: formattedTimeValue
  };
}
export var ViewDateTime = function ViewDateTime(_ref) {
  var dateValue = _ref.dateValue,
    timeValue = _ref.timeValue,
    displayMode = _ref.displayMode;
  var intl = useIntl();
  var _parseDatetimeValueFo = parseDatetimeValueForView(dateValue || '', timeValue || '', intl),
    formattedDateValue = _parseDatetimeValueFo.formattedDateValue,
    formattedTimeValue = _parseDatetimeValueFo.formattedTimeValue;
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    return /*#__PURE__*/React.createElement(LongDisabledQuestionPlaceholder, null, /*#__PURE__*/React.createElement(DateTimeQuestionSubPlaceholder, null, formattedDateValue), /*#__PURE__*/React.createElement(DateTimeQuestionSubPlaceholder, null, formattedTimeValue));
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, formattedDateValue && !formattedTimeValue && /*#__PURE__*/React.createElement(React.Fragment, null, formattedDateValue), !formattedDateValue && formattedTimeValue && /*#__PURE__*/React.createElement(React.Fragment, null, formattedTimeValue), formattedDateValue && formattedTimeValue &&
  /*#__PURE__*/
  // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
  React.createElement(React.Fragment, null, "".concat(formattedDateValue, ", ").concat(formattedTimeValue)));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var DateTimeQuestionSubPlaceholder = styled.div({
  width: '50%',
  padding: "var(--ds-space-100, 8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var LongDisabledQuestionPlaceholder = styled.div({
  borderStyle: 'solid',
  borderColor: "var(--ds-border-disabled, #DFE1E6)",
  borderRadius: "var(--ds-radius-small, 3px)",
  borderWidth: "var(--ds-border-width, 2px)",
  backgroundColor: "var(--ds-background-accent-gray-subtlest, ".concat(N20, ")"),
  cursor: 'default',
  height: '42px',
  display: 'flex',
  alignItems: 'center',
  color: "var(--ds-text-disabled, ".concat(N70, ")"),
  width: '320px'
});